import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/cardapio';

class MenuService {
  static async getAllRecipes(params = {}) {
    const clientCode = sessionStorage.getItem('clientCode');

    const requestParams = {
      clientCode,
      search: params.search || '',
      page: params.currentPage ?? params.page ?? 0,
      size: params.pageSize ?? params.size ?? 10,
      sort: params.sort || ''
    };

    if (params.active !== undefined && params.active !== null) {
      requestParams.active = params.active;
    }

    if (params.minPrice !== undefined) requestParams.minPrice = params.minPrice;
    if (params.maxPrice !== undefined) requestParams.maxPrice = params.maxPrice;

    if (params.categories && Array.isArray(params.categories)) {
      requestParams.categories = params.categories;
    }

    const response = await api.get(
      `${BASE_PATH}/listarReceitas`,
      { params: requestParams }
    );
    return response.data;
  }

  static async findSpecificRecipe(recipeId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarReceita`,
      { params: { clientCode, searchInput: recipeId } }
    );
    return response.data;
  }

  static async getActiveRecipes(currentPage, pageSize) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, page: currentPage, size: pageSize };
    const response = await api.get(
      `${BASE_PATH}/listarReceitasAtivasNoCardapio`,
      { params }
    );
    return response.data;
  }

  static async registerRecipe(recipe) {
    const response = await api.post(
      `${BASE_PATH}/adicionarReceita`,
      recipe
    );
    return response.data;
  }

  static async updateRecipe(recipeId, recipe) {
    const response = await api.put(
      `${BASE_PATH}/atualizarReceita`,
      recipe,
      { params: { recipeId } }
    );
    return response.data;
  }

  static async updateRecipeQuantity(searchInput, action, recipe) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput, action };
    const response = await api.put(
      `${BASE_PATH}/atualizarQuantidadeReceita`,
      recipe,
      { params }
    );
    return response.data;
  }

  static async deleteRecipe(recipeId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerReceita`,
      { params: { clientCode, recipeId } }
    );
    return response.data;
  }

  static async getCompleteActiveMenu({
    search = '',
    categories = [],
    minPrice,
    maxPrice,
    currentPage,
    pageSize
  }) {
    const clientCode = sessionStorage.getItem('clientCode');

    const requestParams = {
      clientCode,
      page: currentPage,
      size: pageSize,
    };

    if (search && search.trim()) {
      requestParams.search = search.trim();
    }

    if (categories && Array.isArray(categories) && categories.length > 0) {
      requestParams.categories = categories;
    }

    if (minPrice !== undefined && minPrice !== null) {
      requestParams.minPrice = minPrice;
    }

    if (maxPrice !== undefined && maxPrice !== null) {
      requestParams.maxPrice = maxPrice;
    }

    const response = await api.get(
      `${BASE_PATH}/listarCardapioCompleto`,
      {
        params: requestParams,
      }
    );

    return response.data;
  }

  static async getRecipesByInput(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarReceitas`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async batchStatusUpdate(payload, type) {
    const clientCode = sessionStorage.getItem("clientCode");

    const response = await api.put(
      `${BASE_PATH}/atualizarStatusEmMassa`,
      payload,
      {
        params: {
          clientCode: clientCode,
          itemType: type
        }
      }
    );
    return response.data;
  }


  static async returnItems(orderItemDTO) {
    const response = await api.put(`${BASE_PATH}/retornarItems`, orderItemDTO);
    return response.data;
  }
}

export default MenuService;